import { c as _c } from "react/compiler-runtime";
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { Card } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import groupRuleResults from '@/entities/components/details/utils/group-rule-results';
import { getOnboardingQueries, isAwaitingResults } from '../../utils/onboarding-queries';
import { CardError, CardSkeleton } from '../card-title';
import Subsection from '../subsection';
import Content from './components/content';
import RulesToggle from './components/rules-toggle';
type OnboardingRulesProps = {
  entity: Pick<Entity, 'id' | 'kind'>;
  onboarding: EntityOnboarding;
};
const OnboardingRules = t0 => {
  const $ = _c(13);
  const {
    entity,
    onboarding
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const [showTriggeredRules, setShowTriggeredRules] = useState(true);
  let t2;
  if ($[1] !== entity || $[2] !== onboarding) {
    t2 = getOnboardingQueries(entity, onboarding);
    $[1] = entity;
    $[2] = onboarding;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data,
    isPending,
    error
  } = useQuery(t2.ruleSetResult);
  const noRuleResults = !onboarding.ruleSetResults.length || data?.ruleResults.length === 0;
  if (error && !data) {
    let t3;
    if ($[4] !== error) {
      t3 = <Subsection><CardError error={error} /></Subsection>;
      $[4] = error;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== data || $[7] !== isPending || $[8] !== noRuleResults || $[9] !== onboarding || $[10] !== showTriggeredRules || $[11] !== t) {
    t3 = <Subsection>{noRuleResults ? <Card.Root><Card.Empty>{isAwaitingResults(onboarding) ? t(_temp) : t(_temp2)}</Card.Empty></Card.Root> : <div className="flex flex-col items-start gap-4"><RulesToggle onClick={setShowTriggeredRules} />{data && <Content ruleResults={groupRuleResults(data.ruleResults)[showTriggeredRules ? "triggered" : "notTriggered"]} showTriggered={showTriggeredRules} />}{isPending && <CardSkeleton />}</div>}</Subsection>;
    $[6] = data;
    $[7] = isPending;
    $[8] = noRuleResults;
    $[9] = onboarding;
    $[10] = showTriggeredRules;
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default OnboardingRules;
function _temp($) {
  return $.onboardingTrace.rulesPending;
}
function _temp2($_0) {
  return $_0.rules.noRuleResults;
}